import { z } from 'zod';

export const InfoPrivacyType = {
  Profilazione: 1,
  MarketingEmail: 2,
  MarketingSms: 3,
  MarketingPhone: 4,
} as const;

const infoPrivacySchema = z.object({
  type: z.union([
    z.literal(InfoPrivacyType.Profilazione),
    z.literal(InfoPrivacyType.MarketingEmail),
    z.literal(InfoPrivacyType.MarketingSms),
    z.literal(InfoPrivacyType.MarketingPhone),
  ]),
  flag: z.boolean(),
  checkVisionState: z.number().optional(),
  description: z.string().optional(),
});

export type InfoPrivacy = z.infer<typeof infoPrivacySchema>;

export const getInfoPrivacyResponseSchema = z.object({
  status: z.string(),
  requestId: z.string(),
  datetime: z.string(),
  flagCompliant: z.boolean(),
  infoPrivacy: z.array(infoPrivacySchema),
});

export type GetInfoPrivacyResponse = z.infer<
  typeof getInfoPrivacyResponseSchema
>;

export type InfoPrivacyRequestPayload = {
  infoPrivacyList: InfoPrivacy[];
};
